import React, {useState, useEffect} from "react";
import {useLocation} from "react-router-dom";
import {useSelector, useDispatch} from "react-redux";
import get from "lodash/get";
import map from "lodash/map";
import sumBy from "lodash/sumBy";
import {withButtonLoader} from "../../helpers";
import {
    getPaymentsToken,
    getUserData,
    getAdminUserData,
    updateUserData, onTransactionLoading, transactionError, savePaymentsData,
} from "../../Actions/authActions";
import {
    formatCreditCardNumber,
    formatExpirationDate,
    formatCVC,
} from "../Payments/utils";
import {amountFormatter, amountFormatterWithZero, eventUrl} from "../../utils";
import CustomCheckbox from "../../Components/CustomCheckBox";
import "../Payments/payments.css";
import {CrossIcon, DownArrowIcon} from "../../Components/Icons";
import {PaymentFactory} from "../../Payments/paymentFactory";
import {postManualPayment} from "../../Payments/postManualPayment.js";
import {handleSubmit} from "../../Payments/handleSubmit.js";
import PaymentSuccessPopup from "../Payments/paymentSuccessPopup";
import {useNavigate} from "react-router";
import CardExpiration from "../../Components/Forms/CardExpiration";
import {showPaymentError} from "../../Payments/errorHandler";

const EditCardInfo = (props) => {

    const {patientPayerInfo} = props;
    const subdomain = props.subdomain;
    const paymentMethodData = props.paymentMethodData;
    const setEditCardInfo = props.setEditCardInfo;
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const user = useSelector((state) => state.auth.user);
    const adminUser = useSelector((state) => state.auth.adminUser);
    const transactionLoading = useSelector(
        (state) => state.auth.transactionLoading
    );
    // const [showDefaultChecked, setShowDefaultChecked] = useState();
    const [isPaymentSaveDetails, setIsPaymentSaveDetails] = useState(true);

    useEffect(() => {
        setPaymentInfo({
            pmtMethodDescription: "eCheck",
            cardFirstName: paymentMethodData?.ssl_first_name,
            cardLastName: paymentMethodData?.ssl_last_name,
            accountFirstName: paymentMethodData?.ssl_first_name,
            accountLastName: paymentMethodData?.ssl_last_name,
            companyName: paymentMethodData?.ssl_company,
            bankName: paymentMethodData?.bankName,
            bankAccountType: paymentMethodData?.ssl_bank_account_type,
            bankRoutingNumber: paymentMethodData?.ssl_aba_number?.slice(-4),
            bankAccountNumber: paymentMethodData?.ssl_bank_account_number.slice(-4),
        });
        if (paymentMethodData?.ssl_bank_account_type) {
            setAccountType(paymentMethodData?.ssl_bank_account_type);
        }
    }, []);

    useEffect(() => {
        dispatch(getAdminUserData(subdomain));
        initManualPayment();
    }, [!adminUser]);

    const initManualPayment = async () => {
        const factory = new PaymentFactory();
        const newManual = await factory.create('MANUAL', {
            subdomain, adminUser, user
        });
        setManual(newManual);
    }


    const runTransactionLoading = () => {
        dispatch(onTransactionLoading());
    }
    const runGetUserData = () => {
        dispatch(getUserData(subdomain));
    }
    const runPayUserSuccess = () => {
        dispatch({type: "PAYUSER_SUCCESS"});
    }
    const runTransactionError = () => {
        dispatch(transactionError());
    }

    const callSubmit = async (event) => {
        event.preventDefault();
        const target = event.target;
        const submit = {
            target,
            paymentInfo,
            patientPayerInfo,
            paymentType,
            totalAmountsPaid,
            user,
            adminUser,
            subdomain,
            isPaymentSaveDetails,
            isDefault,
            accountType,
            manual,
            showResult,
            runTransactionLoading,
            runGetUserData,
            runPayUserSuccess,
            runTransactionError,
            savePaymentsData,
            setPaymentInfo,
            dispatch,
            oldData: paymentMethodData
        };
        await handleSubmit(submit);

    }


    useEffect(() => {
        if (!user.id) {
            dispatch(getUserData(subdomain));
        }
    }, [!user]);

    useEffect(() => {
        if (paymentMethodData) {
            setPaymentType(paymentMethodData.paymentType);
            setIsDefault(paymentMethodData.isDefault);
        }
    }, [paymentMethodData]);

    function showResult(status, err) {
        if (status === "approval" && userPurpose === 'editPaymentMethod') {
            setPaymentMsg("editSuccessful");
            setPaymentStatus("approval");
        } else if (status === "txnApprovedButPmtMethodNotStored") {
            setPaymentStatus("approval");
            setPaymentMsg("The payment was successful. Unable to store payment method at this time.");
        } else if (status === "failure" || status === "error") {
            setPaymentMsg(`${showPaymentError(err)}`);
            setPaymentStatus("error");
        }
        setOpenModal(true);
    }

    const onCloseModal = () => {
        if (paymentStatus === "approval") {
            setOpenModal(false);
            setEditCardInfo(false);
            navigate(`${eventUrl(subdomain)}payments`);
        } else {
            setOpenModal(false);
        }
    };

    // currently  commented need to review
    // useEffect(() => {
    //   if (user) {
    //     setShowDefaultChecked(user.paymentMethods);
    //   }
    // }, [user]);

    //  previously commented

    // useEffect(() => {
    //   if (user && user.paymentMethods) {
    //     const { paymentMethods } = user || "";
    //     const filterData = filter(paymentMethods, (p) => p.isDefault)[0];
    //     if (filterData && filterData._id) {
    //       setSelectedCardId(filterData._id);
    //     }
    //     setSelectedPayment(filterData);
    //   }
    // }, [user]);

    const totalAmountsPaid = () => {
        return 0;
    };


    const handleInputChange = ({target}) => {
        if (target.name === "cardnumber") {
            target.value = formatCreditCardNumber(target.value);
        } else if (target.name === "expiry") {
            target.value = formatExpirationDate(target.value);
        } else if (target.name === "cvc") {
            target.value = formatCVC(target.value);
        } else if (target.name === "accountType") {
            setAccountType(target.value)
        }
        setPaymentInfo({...paymentInfo, [target.name]: target.value});
    };

    return (
        <>
            <div className="cross-btn" onClick={() => {
                setEditCardInfo(false)
                navigate(`${eventUrl(subdomain)}home`);
            }}>
                <CrossIcon/>
            </div>
            <div
                className="creditCard"
                id="pills-profile"
                role="tabpanel"
                aria-labelledby="pills-profile-tab"
            >
                <div className="sos-content edit-payment-header payment-inner-toggleable">
                    <div className="edit-card-info mb-5">
                        <h3>Edit Payment Information</h3>
                    </div>
                    <form onSubmit={(event) => callSubmit(event)}>
                        {paymentType !== "eCheck" ? (
                            <>
                                <div className="form-group mb-3">
                                    <label
                                        htmlFor="exampleInputEmail1"
                                        className="form-label payment-form-label"
                                    >
                                        Cardholder Name
                                    </label>
                                    <div className="row g-2">
                                        <div className="col-md">
                                            <div className="payment-controlpanl-style">
                                                <input
                                                    type="text"
                                                    name="cardFirstName"
                                                    className="form-control custom-input-border-css"
                                                    id="exampleInputName3"
                                                    aria-describedby="nameHelp"
                                                    onChange={(e) => handleInputChange(e)}
                                                    placeholder={paymentMethodData?.ssl_first_name || ""}
                                                    value={paymentInfo.cardFirstName}
                                                    required
                                                />

                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div>
                                                <input
                                                    type="text"
                                                    name="cardLastName"
                                                    className="form-control custom-input-border-css"
                                                    id="exampleInputName3"
                                                    aria-describedby="nameHelp"
                                                    onChange={(e) => handleInputChange(e)}
                                                    placeholder={paymentMethodData?.ssl_last_name || ""}
                                                    // value={paymentMethodData?.ssl_last_name}
                                                    value={paymentInfo.cardLastName}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group mb-3">
                                    <label
                                        htmlFor="exampleInputPassword1"
                                        className="form-label payment-form-label"
                                    >
                                        Credit Card Number
                                    </label>
                                    <input
                                        type="tel"
                                        name="cardnumber"
                                        className="form-control custom-input-border-css bg-white"
                                        id="cardnumber"
                                        placeholder={`**** **** **** ${paymentMethodData?.ssl_card_number?.slice(-4) || ""}`}
                                        pattern="[\d ]{15,22}"
                                        required
                                        onChange={(e) => handleInputChange(e)}
                                    />
                                </div>
                                <div className="row g-2">
                                    <div className="col-md">
                                        <div className="payment-controlpanl-style">
                                            <div>
                                                <label className="payment-form-label">
                                                    Expiry Date
                                                </label>
                                            </div>
                                            <CardExpiration
                                                onChange={(e) => handleInputChange(e)}
                                            ></CardExpiration>
                                            {/*<input*/}
                                            {/*    type="tel"*/}
                                            {/*    className="form-control custom-input-border-css bg-white"*/}
                                            {/*    id="expiry"*/}
                                            {/*    placeholder="mm/yy"*/}
                                            {/*    name="expiry"*/}
                                            {/*    pattern="\d\d/\d\d"*/}
                                            {/*    required*/}
                                            {/*    */}
                                            {/*/>*/}
                                        </div>
                                    </div>
                                    <div className="col-md">
                                        <div>
                                            <div>
                                                <label className="payment-form-label">
                                                    Security Code
                                                </label>
                                            </div>
                                            <input
                                                type="tel"
                                                className="form-control custom-input-border-css bg-white"
                                                placeholder="Enter CVC"
                                                name="cvc"
                                                pattern="\d{3,4}"
                                                required
                                                onChange={(e) => handleInputChange(e)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="checkbox-list mt-3">
                                    <label className="label-check font-weight-light ">
                                        <CustomCheckbox defaultChecked/>
                                        <span>Save these payment details for future payments</span>
                                    </label>
                                    <div className="payment-checbox">
                                        <label className="font-weight-light label-check ml-xl-5">
                                            <CustomCheckbox
                                                onChange={(e) => setIsDefault(e.target.checked)}
                                                defaultChecked={paymentMethodData?.isDefault}
                                            />
                                            <span className="word-break: break-word">
                        Set as default payment method
                      </span>
                                        </label>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                {/* <div className="form-group mb-3"> */}
                                {/* <label
                    htmlFor="exampleInputName1"
                    className="form-label payment-form-label"
                  >
                    Name
                  </label> */}
                                <div className="dropdown custom-dropdown mb-3">
                                    <select
                                        name="accountType"
                                        className="form-control bg-white"
                                        required
                                        value={paymentInfo.accountType}
                                        onChange={(e) => handleInputChange(e)}
                                    >
                                        {(typeof paymentInfo.accountType !== 'undefined') ? (
                                            <option selected value="">
                                                Account Type
                                            </option>
                                        ) : ""}
                                        <option value="0">Personal</option>
                                        <option value="1">Business</option>
                                    </select>
                                    <div className="down-arrow">
                                        <DownArrowIcon/>
                                    </div>
                                </div>

                                {accountType == "0" ?
                                    (
                                        <div className="form-group mb-3">
                                            <label
                                                htmlFor="exampleInputBankName1"
                                                className="form-label payment-form-label"
                                            >
                                                Name On Account
                                            </label>
                                            <div className="row g-2">
                                                <div className="col-md">
                                                    <div className="payment-controlpanl-style">
                                                        <input
                                                            type="text"
                                                            name="accountFirstName"
                                                            className="form-control custom-input-border-css"
                                                            id="exampleInputName3"
                                                            aria-describedby="nameHelp"
                                                            placeholder="First Name"
                                                            onChange={(e) => handleInputChange(e)}
                                                            value={paymentInfo.accountFirstName}
                                                            required
                                                        />

                                                    </div>
                                                </div>
                                                <div className="col-md">
                                                    <div>
                                                        <input
                                                            type="text"
                                                            name="accountLastName"
                                                            className="form-control custom-input-border-css"
                                                            id="exampleInputName3"
                                                            aria-describedby="nameHelp"
                                                            placeholder="Last Name"
                                                            onChange={(e) => handleInputChange(e)}
                                                            value={paymentInfo.accountLastName}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (

                                        <div className="form-group mb-3">
                                            <label
                                                htmlFor="exampleInputBankName1"
                                                className="form-label payment-form-label"
                                            >
                                                Name On Account
                                            </label>
                                            <input
                                                type="text"
                                                name="companyName"
                                                required
                                                className="form-control custom-input-border-css"
                                                id="exampleInputName1"
                                                aria-describedby="nameHelp"
                                                value={paymentInfo.companyName}
                                                placeholder="Enter Name on the Account"
                                            />

                                        </div>
                                    )}
                                {/* </div> */}
                                <div className="form-group mb-3">
                                    <label
                                        htmlFor="exampleInputBankName1"
                                        className="form-label payment-form-label"
                                    >
                                        Bank Name
                                    </label>
                                    <input
                                        type="text"
                                        name="bankName"
                                        required
                                        className="form-control bg-white"
                                        id="exampleInputBankName"
                                        aria-describedby="bankNameHelp"
                                        placeholder={paymentInfo.bankName}
                                    />
                                </div>
                                <div className="form-group mb-3">
                                    <label
                                        htmlFor="exampleInputBankNumber1"
                                        className="form-label payment-form-label"
                                    >
                                        Bank Routing Number
                                    </label>
                                    <input
                                        type="text"
                                        required
                                        className="form-control bg-white"
                                        name="bankRoutingNumber"
                                        id="exampleInputBankNumber1"
                                        value={paymentInfo.bankRoutingNumber}
                                        placeholder="Enter Bank Routing Number"
                                    />
                                </div>
                                <div className="form-group mb-3">
                                    <label
                                        htmlFor="exampleInputAccountNumber1"
                                        className="form-label payment-form-label"
                                    >
                                        Bank Account Number
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control bg-white"
                                        id="exampleInputAccountNumber1"
                                        required
                                        name="bankAccountNumber"
                                        placeholder={'**** **** **** ' + paymentInfo.bankAccountNumber}
                                    />
                                </div>

                                <div className="checkbox-list mt-3">
                                    <label className="label-check font-weight-light float-end">
                                        <CustomCheckbox
                                            checked={isPaymentSaveDetails}
                                            onChange={(e) =>
                                                setIsPaymentSaveDetails(e.target.checked)
                                            }
                                        />
                                        Save these payment details for future payments
                                    </label>
                                    <div className="payment-checbox">
                                        <label className="font-weight-light label-check ml-xl-5">
                                            <CustomCheckbox
                                                name="isDefault"
                                                onChange={(e) => setIsDefault(e.target.checked)}
                                            />
                                            Set as default payment method
                                        </label>
                                    </div>
                                </div>
                            </>
                        )}
                        <div className="checkbox-list mt-3">
                            <div className="d-flex justify-content-center">
                                <button
                                    type="submit"
                                    className="save-payment-btn sos-custom-btn-css"
                                >
                                    {withButtonLoader(
                                        "Save Payment Information",
                                        transactionLoading, "#fff"
                                    )}
                                    {/* #6e86c4 */}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div className="hommeexisting-img-edit">
                <img src="../images/payment-icon.png"/>
            </div>
            {openModal && <PaymentSuccessPopup
                openModal={openModal}
                paymentMsg={paymentMsg}
                onCloseModal={onCloseModal}
            />}
        </>
    );
};

export default EditCardInfo;
